import { DomainUpsertLoadingList } from "@/components/domain";
import { useSyncLoading } from "@/context/sheet";
import {
  useGetPaymentAdjustment,
  useUpdatePaymentAdjustment,
} from "@/hooks/payment-adjustment";
import { createFileRoute } from "@tanstack/react-router";
import { Form } from "./-form";
import { CreatePaymentAdjustment } from "@/models/payment-adjustment";
import { useGetReservationClients } from "@/hooks/reservation-clients";

export const Route = createFileRoute(
  "/(payment-adjustments)/payment-adjustments/$id/_sheet/$pid",
)({
  component: RouteComponent,
});
function RouteComponent() {
  const { pid, id } = Route.useParams();

  const { isLoading, data: model } = useGetPaymentAdjustment(pid);
  const { isLoading: clientsLoading, data: clientsData } =
    useGetReservationClients(id);
  const { mutateAsync } = useUpdatePaymentAdjustment();

  const update = async (paymentAdjustment: CreatePaymentAdjustment) => {
    await mutateAsync({
      ...paymentAdjustment,
      id: model!.id,
    });
  };
  useSyncLoading(isLoading);

  if (isLoading || clientsLoading) {
    return <DomainUpsertLoadingList />;
  }

  return (
    <Form
      onUpsert={update}
      reservationId={id}
      reservationClients={clientsData ?? []}
    />
  );
}
